import { render, staticRenderFns } from "./CrowdxWhitePaper.vue?vue&type=template&id=23eafc5a&scoped=true"
import script from "./CrowdxWhitePaper.vue?vue&type=script&lang=js"
export * from "./CrowdxWhitePaper.vue?vue&type=script&lang=js"
import style0 from "./CrowdxWhitePaper.vue?vue&type=style&index=0&id=23eafc5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eafc5a",
  null
  
)

export default component.exports